import UserCookie from 'vue-cookies'

export default function auth ( { next } ) {
    if(UserCookie.get('loggedin')&&UserCookie.get('usermembn')){
        return next()
    } else {
        return next('/')
    }
}
